export const disableScroll = (scrollPosition) => {
    document.body.style.top = `-${scrollPosition}px`;
    document.body.classList.add('disable-scroll');
};

export const enableScroll = (scrollPosition) => {
    document.body.classList.remove('disable-scroll');
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
};
